Postlogin.Career = (function () {
    const me = {};

    me.page_load_id = Math.random().toString(36).substr(2, 10);

    me.init = function () {
        const handleResize = _.debounce(() => {
            me.sizeStars();
            $('.video-carousel').flickity('destroy');
            $('.video-carousel .video').removeAttr('style');
            $('.video-carousel').flickity({
                cellSelector: '.video',
                cellAlign: 'left',
                groupCells: '80%',
                adaptiveHeight: false,
                resize: true,
            });
        }, 250);

        const interest = $('#stars').attr('data-rating');

        $('.starrr').starrr({
            max: 10,
            rating: interest,
            emptyClass: 'star empty-star fa fa-star',
            fullClass: 'star full-star fa fa-star',
            change(e, value) {
                // only save value if we have a value to save.
                // for some reason, clicking on the recently saved star causes this to be 'undefined'
                if (typeof value !== 'undefined' && value > 0 && value <= 10) {
                    me.saveCareerInterest(value);

                    $('.starrr').addClass('animated tada');
                    setTimeout(() => {
                        $('.starrr').removeClass('animated tada');
                    }, 1000);
                } else {
                    me.clearCareerInterest();

                    $('.starrr').addClass('animated shake');
                    setTimeout(() => {
                        $('.starrr').removeClass('animated shake');
                    }, 1000);
                }
            },
        });
        function labelStars() {
            $('.starrr').each(function () {
                $(this).find('a').each(function (i) {
                    $(this).attr('aria-label', 'Rate ' + (i + 1) + ' of 10');
                });
            });
        }
        labelStars();

        $('.career-journal-notes-fields textarea').each(function () {
            $(this).keyup(function () {
                $(this).prev().find('.message').removeClass('animated tada')
                    .html('');
            });
            $(this).keyup(
                _.debounce(function () {
                    const field = $(this).attr('name');
                    const value = $(this).val();
                    if (!value.split('').filter((character) => character !== ' ').length >= 1) {
                        $(this).prev().find('.message').fadeIn(150);
                        $(this).prev().find('.message').html('...NOTHING TO SAVE')
                            .addClass('animated tada');
                        $(this).prev().find('.message').delay(3000)
                            .fadeOut(3000);
                    } else {
                        me.saveCareerJournalField(field, value);
                        $(this).prev().find('.message').fadeIn(150);
                        $(this).prev().find('.message').html('...SAVED')
                            .addClass('animated tada');
                        $(this).prev().find('.message').delay(3000)
                            .fadeOut(3000);
                    }
                }, 750),
            );
        });

        $('#save-career-journal').on('click', (e) => {
            e.preventDefault();
            $('.career-journal-notes-fields textarea').each(function () {
                const field = $(this).attr('name');
                const value = $(this).val();
                if (!value.split('').filter((character) => character !== ' ').length >= 1) {
                    $(this).prev().find('.message').fadeIn(150);
                    $(this).prev().find('.message').html('...NOTHING TO SAVE')
                        .addClass('animated tada');
                    $(this).prev().find('.message').delay(3000)
                        .fadeOut(3000);
                } else {
                    me.saveCareerJournalField(field, value);
                    $(this).prev().find('.message').fadeIn(150);
                    $(this).prev().find('.message').html('...SAVED')
                        .addClass('animated tada');
                    $(this).prev().find('.message').delay(3000)
                        .fadeOut(3000);
                }
            });
        });

        $('.career-information .nav-tabs > li:first-child').addClass('active');
        $('.career-information .tab-content > .tab-pane:first-child').addClass('active');
        $('.ooh-tab-table').addClass('table table-bordered table-striped');

        // find any relative links and remove their linkyness
        const links = $('.tab-pane .content a');
        $(links).each(function (index, link) {
            const url = $(this).attr('href');
            if (!url || typeof url !== 'string') return;
            if (!url.startsWith('http') || url.startsWith('/ooh')) {
                const linkText = $(link).text();
                $(link).after(linkText);
                $(link).remove();
            }
        });

        const images = $('.section .content img');
        $(images).each((index, image) => {
            $(image).addClass('img-responsive');
        });

        // adding a 'ready' event to Flickity
        const { activate } = Flickity.prototype;
        Flickity.prototype.activate = function () {
            if (this.isActive) {
                return;
            }
            activate.apply(this, arguments);
            this.dispatchEvent('ready');
        };

        // using that 'ready' event to change the CSS of the video element
        // so all containers share the same height.
        // If I put this CSS on the .video element initially... for some reason
        // Flickity doesn't display the elements at all
        $('.video-carousel').on('ready.flickity', () => {
            $('.video-carousel .video').css('height', '100%');
            $('.video-carousel .video').css('display', 'block');
            $('.video-carousel .video').css('width', 'calc(50% - 12px)');
            setTimeout(() => {
                $('.video-carousel .video').css('display', 'flex');
            }, 500);
        });

        $('.video-carousel').flickity({
            cellSelector: '.video',
            cellAlign: 'left',
            groupCells: '80%',
            adaptiveHeight: false,
            resize: true,
        });

        Postlogin.CareerCentralVideo.init({
            videoType: 'Job Shadow',
            pageLoadId: me.page_load_id,
            onPercentWatched: me.savePercentWatched,
        });

        $(window).on('resize', handleResize);

        handleResize();
    };

    me.savePercentWatched = function (videoData) {
        $.post(`${window.location.href.split('#')[0].replace(/\/?$/, '/')}savePercentWatched/`, videoData, () => {});
    };

    me.saveCareerInterest = function (value) {
        $.post(`${window.location.href.split('#')[0].replace(/\/?$/, '/')}saveCareerInterest/${value}/`, () => {});
    };

    me.clearCareerInterest = function () {
        $.post(`${window.location.href.split('#')[0].replace(/\/?$/, '/')}clearCareerInterest/`, () => {});
    };

    me.saveCareerJournalField = function (field, value) {
        $.post(`${window.location.href.split('#')[0].replace(/\/?$/, '/')}saveCareerJournalField/${field}`, { value }, () => {});
    };

    me.sizeStars = function () {
        $('.career #stars > a').css('font-size', '12px');
        $('.career #stars > a').each(function (index) {
            $(this).attr('aria-label', `Rate ${index + 1} of 10`);
        });
        const width = $('.career #stars').width();
        let starWidth = $('.career #stars > a').width();

        let originalFontSize = 12;
        originalFontSize = $('.career #stars > a').css('font-size');
        if (typeof originalFontSize !== 'undefined' && originalFontSize !== '') {
            originalFontSize = originalFontSize.replace(/[^-\d.]/g, '');
        }
        let newFontSize = originalFontSize;

        while (starWidth * 10 < width) {
            newFontSize++;
            $('.career #stars > a').css('font-size', `${newFontSize}px`);
            starWidth = $('#stars > a').width();
        }
        newFontSize--;
        $('.career #stars > a').css('font-size', `${newFontSize}px`);
    };

    return {
        init: me.init,
    };
}());
